import React from 'react'

/**
 * Remove acentos e deixa tudo minúsculo para comparação.
 */
export const normalizeString = (str: string): string => {
    return str.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
}

/**
 * Retorna um array de elementos React com partes da string original destacando o termo de busca.
 * O termo é destacado mesmo com diferença de acento ou case.
 */
export const highlightText = (
    text: string,
    search: string,
    highlightStyle?: React.CSSProperties
): React.ReactNode => {
    if (!search) return text;

    const normalizedText = normalizeString(text);
    const normalizedSearch = normalizeString(search);

    const parts: React.ReactNode[] = [];
    let currentIndex = 0;

    while (currentIndex < text.length) {
        const substring = normalizedText.substring(currentIndex);
        const matchIndex = substring.indexOf(normalizedSearch);

        if (matchIndex === -1) {
            // Sem mais ocorrências → adiciona o restante do texto
            parts.push(text.substring(currentIndex));
            break;
        }

        // Adiciona a parte antes do match
        if (matchIndex > 0) {
            parts.push(text.substring(currentIndex, currentIndex + matchIndex));
        }

        // Adiciona o trecho encontrado, destacado
        const originalMatch = text.substring(
            currentIndex + matchIndex,
            currentIndex + matchIndex + search.length
        );

        parts.push(
            <span
                key={currentIndex}
                style={
                    highlightStyle ?? {
                        fontWeight: 'bold',
                    }
                }
            >
                {originalMatch}
            </span>
        );

        currentIndex += matchIndex + search.length;
    }

    return <>{parts}</>;
};
